import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { DEFAULT_BORDER_WIDTH, DEFAULT_BORDER_RADIUS } from 'common/entities/form/styleConfiguration/defaultValues';

import PopoverAnchor from 'common/components/PopoverAnchor';
import BorderPickerOptions from './BorderPickerOptions';
import BorderPickerDropdown from './BorderPickerDropdown';

export default class BorderEditor extends Component {
    static propTypes = {
        borderWidths: PropTypes.object,
        onBorderWidthsChanged: PropTypes.func.isRequired,
        borderRadius: PropTypes.number,
        onBorderRadiusChanged: PropTypes.func.isRequired,
        onChangeTopBorderWidth: PropTypes.func.isRequired,
        onChangeBottomBorderWidth: PropTypes.func.isRequired,
        onChangeRightBorderWidth: PropTypes.func.isRequired,
        onChangeLeftBorderWidth: PropTypes.func.isRequired,
        borderOptionsQa: PropTypes.string,
        borderDropdownQa: PropTypes.string,
        componentLabel: PropTypes.string,
        'aria-label': PropTypes.string,
    };

    static defaultProps = {
        borderWidths: {},
        borderRadius: DEFAULT_BORDER_RADIUS,
        borderOptionsQa: '',
        borderDropdownQa: '',
        componentLabel: '',
        'aria-label': undefined,
    };

    getBorderSize = (borderSize) => (typeof borderSize !== 'undefined' ? borderSize : DEFAULT_BORDER_WIDTH);

    getDefaultBorders = (borders) => ({
        top: this.getBorderSize(borders.sizes.top),
        bottom: this.getBorderSize(borders.sizes.bottom),
        right: this.getBorderSize(borders.sizes.right),
        left: this.getBorderSize(borders.sizes.left),
    });

    areAllBordersEqual = ({ top, bottom, left, right }) =>
        !![bottom, left, right].reduce((prev, acc) => (prev === acc ? prev : false), top);

    getDefaultBorderWidth = (borders) => (this.areAllBordersEqual(borders) ? borders.top : 0);

    render() {
        const {
            borderWidths,
            borderRadius,
            onBorderWidthsChanged,
            onBorderRadiusChanged,
            onChangeTopBorderWidth,
            onChangeBottomBorderWidth,
            onChangeRightBorderWidth,
            onChangeLeftBorderWidth,
            borderOptionsQa,
            borderDropdownQa,
            componentLabel,
            'aria-label': ariaLabel,
        } = this.props;
        const formattedBorders = this.getDefaultBorders(borderWidths);

        return (
            <React.Fragment>
                <PopoverAnchor>
                    <BorderPickerOptions
                        borderRadius={borderRadius}
                        onBorderRadiusChanged={onBorderRadiusChanged}
                        borderWidths={formattedBorders}
                        onChangeTopBorderWidth={onChangeTopBorderWidth}
                        onChangeBottomBorderWidth={onChangeBottomBorderWidth}
                        onChangeRightBorderWidth={onChangeRightBorderWidth}
                        onChangeLeftBorderWidth={onChangeLeftBorderWidth}
                        qaId={borderOptionsQa}
                        componentLabel={componentLabel}
                    />
                </PopoverAnchor>
                <PopoverAnchor>
                    <BorderPickerDropdown
                        defaultBorderWidth={this.getDefaultBorderWidth(formattedBorders)}
                        onBorderWidthsChanged={onBorderWidthsChanged}
                        qaId={borderDropdownQa}
                        aria-label={ariaLabel}
                    />
                </PopoverAnchor>
            </React.Fragment>
        );
    }
}
